export default __webpack_public_path__ + "static/media/gatsby.469fded9.svg";